import React from "react";

import "./Tooltip.css";
import { Tooltip } from "@material-ui/core";

const TooltipComponent = ({ children, data }) => {
  const content = data?.map((item) => (
    <div key={item.id} className="tooltip-container">
      <p className="tooltip-title">{item.title}</p>
      <p className="tooltip-description">{item.description}</p>
    </div>
  ));

  return (
    <>
      <Tooltip
        className="d-inline m-0"
        componentsprops={{
          tooltip: {
            sx: {
              bgolor: "#FFFFFF !important",
              color: "black !important",
              borderRadius: "12px",
              boxShadow: "white !important",
              fontSize: "14px",
              padding: "10px 3px",
            },
          },
          arrow: {
            sx: {
              color: "#FFFFFF !important",
              opacity: "1",
            },
          },
        }}
        title={content}
        arrow
      >
        <p>{children}</p>
      </Tooltip>
    </>
  );
};

export default TooltipComponent;
